// extracted by mini-css-extract-plugin
module.exports = {"back":"styles_back__1l5MP"};